var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loadingApi)?_c('div',{staticClass:"loader loading_whole",staticStyle:{"height":"100vh"}},[_c('div',{staticClass:"modified-loader"},[_c('loading')],1)]):_c('router-view'),(_vm.failed === true || !!_vm.failed)?_c('error-popup'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }